import { createAction } from '@reduxjs/toolkit';

export const checkEligibility = createAction('[Eligibility] checkEligibility');
export const checkEligibilitySuccess = createAction('[Eligibility] checkEligibilitySuccess');
export const setLoading = createAction('[Eligibility] setLoading');
export const setDisabled = createAction('[Eligibility] setDisabled');
export const setCreating = createAction('[Eligibility] setCreating');
export const resetButtons = createAction('[Eligibility] resetButtons');
export const initEligibility = createAction('[Eligibility] initEligibility');
export const setInfo = createAction('[Eligibility] setInfo');
export const setHTML = createAction('[Eligibility] setHTML');
export const socketResponseReceived = createAction('[Eligibility] socketResponseReceived');
export const error = createAction('[Eligibility] error');
export const closeErrorModal = createAction('[Eligibility] closeErrorModal');
export const closeFrame = createAction('[Eligibility] closeFrame');
export const loadPortalInfo = createAction('[Eligibility] loadPortalInfo');
export const portalInfoLoaded = createAction('[Eligibility] portalInfoLoaded');
export const setPortalInfo = createAction('[Eligibility] setPortalInfo');
export const expandPortalInfo = createAction('[Eligibility] expandPortalInfo');
export const showChangesModal = createAction('[Eligibility] showChangesModal');
export const hideChangesModal = createAction('[Eligibility] hideChangesModal');
export const acceptChanges = createAction('[Eligibility] acceptChanges');
export const acceptEligibilityResult = createAction('[Eligibility] acceptEligibilityResult');
export const acceptChangesSuccess = createAction('[Eligibility] acceptChangesSuccess');
export const acceptChangesError = createAction('[Eligibility] acceptChangesError');
export const rejectChanges = createAction('[Eligibility] rejectChanges');
export const rejectChangesSuccess = createAction('[Eligibility] rejectChangesSuccess');
export const rejectChangesError = createAction('[Eligibility] rejectChangesError');
export const setAcceptingEligibility = createAction('[Eligibility] setAcceptingEligibility');

// Multi-payer (v2) actions
export const checkMultiEligibility = createAction('[Eligibility] checkMultiEligibility');
export const checkMultiEligibilitySuccess = createAction('[Eligibility] checkMultiEligibilitySuccess');
export const showEligibilityView = createAction('[Eligibility] showEligibilityView');
export const hideEligibilityView = createAction('[Eligibility] hideEligibilityView');
export const acceptMultiChanges = createAction('[Eligibility] acceptMultiChanges');
export const acceptMultiChangesSuccess = createAction('[Eligibility] acceptMultiChangesSuccess');
export const acceptMultiChangesError = createAction('[Eligibility] acceptMultiChangesError');
export const rejectMultiChanges = createAction('[Eligibility] rejectMultiChanges');
export const rejectMultiChangesSuccess = createAction('[Eligibility] rejectMultiChangesSuccess');
export const rejectMultiChangesError = createAction('[Eligibility] rejectMultiChangesError');
export const setAgentProcessing = createAction('[Eligibility] setAgentProcessing');
export const fetchRunStatus = createAction('[Eligibility] fetchRunStatus');
export const fetchRunStatusSuccess = createAction('[Eligibility] fetchRunStatusSuccess');
export const fetchRunStatusFailure = createAction('[Eligibility] fetchRunStatusFailure');

export const eligibilityAgentStatusReceived = createAction('[Eligibility] eligibilityAgentStatusReceived');
export const setAgentStatus = createAction('[Eligibility] setAgentStatus');
export const clearAgentStatus = createAction('[Eligibility] clearAgentStatus');
export const markSelfInitiatedAgentRun = createAction('[Eligibility] markSelfInitiatedAgentRun');

export const fetchAuditEntries = createAction('[Eligibility] fetchAuditEntries');
export const fetchAuditEntriesSuccess = createAction('[Eligibility] fetchAuditEntriesSuccess');
export const fetchAuditEntriesFailure = createAction('[Eligibility] fetchAuditEntriesFailure');
export const resetAuditEntries = createAction('[Eligibility] resetAuditEntries');
